import { motion } from "framer-motion"
import React, { Suspense, useMemo } from "react"

// Not sure why the @/icons import is not working here. Maybe an ide issue cause it was running fine :/
// import { icons } from "@/icons"
import { IconName, icons } from "@/assets/icons"
import { cn } from "@/utilities/etc"

import styles from "./Icon.module.css"

interface Props {
  name: IconName
  size?: "small" | "default" | "large" | "x-large"
  className?: React.HTMLAttributes<HTMLDivElement>["className"]
  // Left and right adds a margin to icon container. Solo is for targetting in other class, ex. buttons
  slot?: "left" | "right" | "solo"
  style?: React.CSSProperties
  retainOriginalColors?: boolean
}

// Class of icon is added for easier targeting of the element in other css modules

const Icon = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  const Element = useMemo(() => icons[props.name], [props.name])

  return (
    <div
      ref={ref}
      className={cn("icon", styles.icon, props.className)}
      data-size={props.size || "default"}
      data-slot={props.slot || undefined}
      data-retain-original-colors={props.retainOriginalColors || undefined}
      style={props.style}
    >
      <Suspense fallback={null}>
        <Element />
      </Suspense>
    </div>
  )
})

export const MotionIcon = motion.create(Icon)

export default Icon
